import { func } from "prop-types"
import { Button } from "@planningcenter/tapestry-react"

const NewEventButton = ({ onNewClick = () => {} }) => {
  return <Button onClick={onNewClick} title="New signup" theme="highContrast" />
}

NewEventButton.propTypes = {
  onNewClick: func
}

export default NewEventButton
